
export enum TrainingStepState
{
    NotPlannedYet = "NotPlannedYet",
    Planning = "Planning",
    Planned = "Planned",
    Done = "Done",
    Canceling = "Canceling",
    Cancelled = "Cancelled",
    Closed = "Closed",
    Undone = "Undone",
    Self = "Self", 
}
